<template>
  <div class="container">
    <content-header :data="[{text:'角色列表', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
      </div>
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 800px">
          <el-table-column
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            prop="name"
            label="角色名">
          </el-table-column>
          <el-table-column
            prop="modifier_name"
            label="操作人"
            width="100">
          </el-table-column>
          <el-table-column
            prop="modified"
            label="操作时间"
            >
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="editHandle(scope)" type="text" size="small" v-if="scope.row.id > 11">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" v-if="scope.row.id > 11">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curObj.row.id ? '修改角色' : '添加角色'" :visible.sync="isNewShow">
          <el-form :model="newObj">
            <el-form-item label="角色名称" :label-width="formLabelWidth">
              <el-input v-model="newObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="功能权限" :label-width="formLabelWidth" >
            	<div class="check-lists">
            		<el-checkbox-group :key="index"  v-for="(item, index) in permission_tree" v-model="newObj.permission_name">
              	<div>
              		<div class="permiss-list"><el-checkbox  :label="item.name" :key="item.name">{{ item.cn_name }}</el-checkbox></div>
              		<span class="permiss-small" v-for="(items, index) in item.child">
              			<el-checkbox  :label="items.name" :key="items.name">{{ items.cn_name }}</el-checkbox>
              		</span>
              	</div>
              </el-checkbox-group>
            	</div>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isNewShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import RoleModel from 'models/role'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        tableData: [],
        permission_tree: [],
        newObj: {
          name: '',
          permission_name: [],
        },
        curObj: {
          row: {}
        },
        isEdit: false,
        isNewShow: false,
        formLabelWidth: '80px',
        key: ''
      }
    },
    created () {
      RoleModel.find().then(res => {
        this.tableData = res.role_list
      })
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods: {
      getPermission (opts) {
        return RoleModel.getPermission(opts)
      },
      initNewHandle () {
        this.newObj = {
          name: '',
          permission_name: [],
        }
        this.getPermission().then(res => {
          this.permission_tree = res.permission_tree
          this.isEdit = false
          this.isNewShow = true
        })
      },
      editHandle (item) {
        this.curObj = item
        this.newObj = {
          name: item.row.name,
          permission_name: []
        }
        this.getPermission({
          roleId: item.row.id
        }).then(res => {
          this.permission_tree = res.permission_tree

          for (let i = 0; i < res.permission_tree.length; i++) {
            if (res.permission_tree[i].checked) {
              this.newObj.permission_name.push(res.permission_tree[i].name)
            }

            if (!res.permission_tree[i].child) continue
            for (let j = 0; j < res.permission_tree[i].child.length; j++) {
              if (res.permission_tree[i].child[j].checked) {
                this.newObj.permission_name.push(res.permission_tree[i].child[j].name)
              }
            }
          }

          this.isEdit = true
          this.isNewShow = true
        })
      },
      deleteHandle (item) {
        this.$confirm('确认删除？')
          .then(_ => {
            RoleModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        console.log(this.newObj)
        if (!this.newObj.name || !this.newObj.permission_name.length) {
          this.$message({ message: '请输入权色名称并选择功能权限', type: 'error' })
          return
        }
        if (this.isEdit) return this.updateHandle()
        this.newHandle()
      },
      newHandle () {
        RoleModel.create({
          name: this.newObj.name,
          permissionName: this.newObj.permission_name.join(','),
        }).then(res => {
          RoleModel.find().then(res => {
            this.tableData = res.role_list
          })
          this.isNewShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: '添加失败', type: 'error' })
        })
      },
      updateHandle () {
        RoleModel.update({
          id: this.curObj.row.id,
          name: this.newObj.name,
          permissionName: this.newObj.permission_name.join(',')
        }).then(() => {
          RoleModel.find().then(res => {
            this.tableData = res.role_list
          })

          this.isNewShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: '更新失败', type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
    .new-wrap
      .el-input
        width: 85%
.super-power
  padding: 20px
  .power-new
    padding-bottom: 20px
  .new-wrap
    .el-input
      width: 293px
    .el-form-item
      margin-bottom: 12px
    .check-title
      width: 80px
    .check-list
      margin-left: 80px
      height: 135px
      overflow: scroll
      border-radius: 4px
      padding: 0 10px
      border: 1px solid #bfcbd9
      .el-checkbox
        margin-left: 0
        margin-right: 15px
        &:first-child
          margin-right: 15px
.permiss-list
	background: #E6E6E6
	margin-bottom:3px
	.el-checkbox
		margin-left: 10px
	.permiss-small
		margin-left:10px
.check-lists
	height:500px
	overflow: scroll
	border: 1px solid #bfcbd9
	border-radius: 4px
</style>



// WEBPACK FOOTER //
// src/views/Role.vue